export const CE_MODAL_OPEN = "CE_MODAL_OPEN";
export const CE_MODAL_CLOSE = "CE_MODAL_CLOSE";
export const CE_MODAL_UPDATE_STATE = "CE_MODAL_UPDATE_STATE";

export const ceModalUpdateState = (state) => ({
  type: CE_MODAL_UPDATE_STATE,
  state: state,
});

export const ceModalClose = () => ({
  type: CE_MODAL_CLOSE,
});
